import styled from 'styled-components'
import PropTypes from 'prop-types'
import Message from 'common/message'

const PictureStyled = styled.div`
  margin: 32px 0;
  .picture-image {
    height: auto;
    margin: 0;
  }
  .picture-description {
    display: block;
    font-size: 14px;
    line-height: 24px;
    color: var(--textOpaque);
    text-align: center;
    margin-top: 16px;
  }
  @media(min-width: 768px) {
    margin: 48px 0;
  }
`

function Picture({ src, alt }) {
  if (alt === 'null') return null

  if (src && alt) {
    return (
      <PictureStyled>
        <img className="picture-image" src={src} alt={alt} width="680px" height="400px" />
        {alt && alt !== 'alt' && <span className="picture-description">{alt}</span>}
      </PictureStyled>
    )
  }

  return (
    <Message
      color="var(--error)!important"
      fontSize="54px!important"
      lineHeight="60px!important"
      error
    >
      Tu imagen carece de algun atributo.
    </Message>
  )
}

Picture.defaultProps = {
  src: '',
  alt: '',
}

Picture.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
}

export default Picture
